import { useReactiveVar } from '@apollo/client';
import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';

import { userAmsUserIdVar } from '../../../constants';
import { UserInfo } from '../../../models/UserAWSCognitoInfo';

export type UseSetUserFromCurrentSessionResponse = {
  userInfo: UserInfo | null;
  loading: boolean;
};

const useSetUserFromCurrentSession = (pathname?: string): UseSetUserFromCurrentSessionResponse => {
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const selectedUserId = useReactiveVar(userAmsUserIdVar);

  useEffect(() => {
    setLoading(true);

    Auth.currentSession()
      .then((session) => {
        if (session.isValid()) {
          setUserInfo(session.getIdToken().decodePayload() as UserInfo);
        }
      })
      .catch(() => void 0)
      .finally(() => {
        setLoading(false);
      });

    return () => {
      setLoading(false);
    };
  }, [selectedUserId, pathname]);

  return {
    loading,
    userInfo,
  };
};

export default useSetUserFromCurrentSession;
